module.exports = __webpack_public_path__ + "img/c9-m.f1eafe1e.jpg";